<template>
    <div>
        <slot>
            <div class="picker-btn" @click.prevent="toggleModal(true)">
                <fa icon="clock"/>
                <input id="iphonePicker" type="time" title="time" v-model="iosTime" @change="iosTimeChanged">
                {{ value }}
            </div>
        </slot>

        <div class="modal fade" :class="{show, 'd-block': show}">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <img src="../assets/img/close_icon.svg" class="ml-auto" width="14px" alt="Close" @click="toggleModal(false)">
                    </div>
                    <div class="modal-body text-center pt-0">
                        <label>{{ title }}</label>
                        <div class="mx-5 d-flex">
                            <div class="col-4 p-0" @click="next('hour')">
                                <fa class="text-grey" icon="angle-up"/>
                            </div>
                            &nbsp;
                            <div class="col-4 p-0" @click="next('minute')">
                                <fa class="text-grey" icon="angle-up"/>
                            </div>
                            <div class="col-4 p-0 text-grey" v-if="amPm !== 'am'" @click="toggleAmPm">am</div>
                        </div>
                        <div class="mx-5 d-flex">
                            <transition name="slide">
                                <div class="col-4 p-0" @wheel="$event.wheelDelta > 0 ? next('hour') : prev('hour')">
                                    {{ (hour.toString().length === 1 ? '0' : '') + hour }}
                                </div>
                            </transition>
                            :
                            <transition name="slide">
                                <div class="col-4 p-0" @wheel="$event.wheelDelta > 0 ? next('minute') : prev('minute')">
                                    {{ (minute.toString().length === 1 ? '0' : '') + minute }}
                                </div>
                            </transition>
                            <div class="col-4 p-0" @wheel="toggleAmPm">{{ amPm }}</div>
                        </div>
                        <div class="mx-5 d-flex">
                            <div class="col-4 p-0" @click="prev('hour')">
                                <fa class="text-grey" icon="angle-down"/>
                            </div>
                            &nbsp;
                            <div class="col-4 p-0" @click="prev('minute')">
                                <fa class="text-grey" icon="angle-down"/>
                            </div>
                            <div class="col-4 p-0 text-grey" v-if="amPm !== 'pm'" @click="toggleAmPm">pm</div>
                        </div>
                    </div>
                    <div class="modal-footer pt-0 border-top-0">
                        <w-button type="button" class="px-4 w-100" :inverse="true" @click="save">Save</w-button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="show" @click="toggleModal(false)" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
    name: 'TimePicker',
    props: {
        value: {},
        title: {
            default: 'Set Dosing time'
        },
        showParent: {
            default: null
        }
    },
    data () {
        return {
            hour: 12,
            minute: 0,
            amPm: 'am',
            show: false,
            picker: null,
            iosTime: '12:00'
        }
    },
    methods: {
        prev (type) {
            this.hour = parseInt(this.hour)
            this.minute = parseInt(this.minute)
            if (type === 'hour') {
                if (this.hour - 1 <= 0) this.hour = 12
                else this.hour--
            } else {
                if (this.minute - 1 < 0) {
                    this.prev('hour')
                    this.minute = 59
                } else this.minute--
            }
        },
        next (type) {
            this.hour = parseInt(this.hour)
            this.minute = parseInt(this.minute)
            if (type === 'hour') {
                if (this.hour >= 12) this.hour = 1
                else this.hour++
            } else {
                if (this.minute + 1 >= 60) {
                    this.next('hour')
                    this.minute = 0
                } else this.minute++
            }
        },
        toggleAmPm () {
            this.amPm = this.amPm === 'am' ? 'pm' : 'am'
        },
        toggleModal (show, iphoneCheck = true) {
            if (!show) this.$emit('closed')
            if (!~navigator.userAgent.toLowerCase().indexOf('iphone') || !iphoneCheck) {
                this.show = show
                const body = document.querySelector('body')
                if (this.show) body.classList.add('modal-open')
                else body.classList.remove('modal-open')
            }
        },
        save () {
            this.$emit('input', `${(this.hour.toString().length === 1 ? '0' : '') + this.hour}:${(this.minute.toString().length === 1 ? '0' : '') + this.minute} ${this.amPm}`)
            this.toggleModal(false)
        },
        iosTimeChanged () {
            if (!this.iosTime) this.iosTime = '12:00'
            this.$emit('input', moment(this.iosTime, 'HH:mm').format('hh:mm a'))
        }
    },
    watch: {
        value () {
            this.hour = this.value.split(':')[0]
            this.minute = this.value.split(':')[1].split(' ')[0]
            this.amPm = this.value.split(':')[1].split(' ')[1]
            this.iosTime = moment(this.value, 'hh:mm a').format('HH:mm')
        },
        showParent (val) {
            this.toggleModal(val, false)
        }
    }
}
</script>

<style scoped>
    .picker-btn {
        border: 1px solid #21B8DC;
        color: #21B8DC;
        line-height: 30px;
        height: 30px;
        width: 153px;
        border-radius: 15px;
        cursor: pointer;
        padding-left: 28px;
    }

    .modal-content {
        margin-top: 100%;
        border-radius: 9px;
    }

    .modal-dialog {
        width: 210px;
        margin-left: auto;
        margin-right: auto;
        color: #1A3F65;
        border-radius: 9px;
    }

    .modal-dialog .modal-header {
        color: #21B8DC;
        padding: 13.3px 13.3px 0 13.3px;
    }

    .modal-dialog .value {
        font-size: 24px;
        font-weight: 600;
    }

    .text-grey {
        color: #C4CFD5;
    }

    #iphonePicker {
        opacity: 0;
    }

    @media (min-width: 768px) {
        #iphonePicker {
            display: none;
        }
    }

    @media (max-width: 768px) {
        #iphonePicker {
            position: absolute;
        }
    }
</style>
